import { render, staticRenderFns } from "./OrderShopifyTotals.vue?vue&type=template&id=11a6cc72&scoped=true&"
import script from "./OrderShopifyTotals.vue?vue&type=script&lang=js&"
export * from "./OrderShopifyTotals.vue?vue&type=script&lang=js&"
import style0 from "./OrderShopifyTotals.vue?vue&type=style&index=0&id=11a6cc72&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a6cc72",
  null
  
)

export default component.exports